
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";

export default function HomePage() {
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    setLoading(false)
  }, []);
  if (loading) {
    return <div><h1 className="flex flex-row justify-center items-center">loading ...</h1></div>
  }

  return (
    <div>
      <body className="bg-white">
        <hr></hr>
        <img src="https://cdn.shopify.com/s/files/1/1789/5809/files/FC_INDO_Mainbanner_WEB_2000x.jpg?v=1614915030" />
        <hr></hr>
        <div className="max-w-2xl mx-auto">
          <br></br>
          <p className="mt-5 font-semibold">
            Flowers aren’t just gifts. Flowers are time-sensitive messages, and
            it’s crucial that they arrive as planned. We make it our mission to
            ensure that every single delivery gets there on time, so that your
            message is heard loud and clear! by going to the official
          </p>

          <script src="https://unpkg.com/flowbite@1.4.0/dist/flowbite.js"></script>
        </div>
        <main className="py-16 container mx-auto px-6 md:px-0">
          <section>
            <h1 className="text-3xl font-bold text-rose-400 mb-10">
              Explore our best seller flowers
            </h1>
            <div className="grid sm:grid-cols-3 gap-4 grid-cols-2">
              <div>
                <div className="bg-gray-300 h-60">
                  <img
                    src="https://cdn.shopify.com/s/files/1/1789/5809/files/01-birthday_80ad8c6f-7c3a-4a7a-a177-d19f6105d478.jpg?v=1590989317"
                    className="bg-gray-300 h-60 object-cover w-full"
                  ></img>
                </div>
                <h3 className="text-lg font-semibold text-gray-500 mt-2">
                  WHY Florist for{" "}
                  <span className="text-gray-700 hover:underline"><Link to="/products/detail/18">Birthday</Link></span>
                </h3>
              </div>
              <div>
                <div className="bg-gray-300 h-60">
                  <img
                    src="https://cdn.shopify.com/s/files/1/1789/5809/files/02-anniversary.jpg?v=1590989336"
                    className="bg-gray-300 h-60 object-cover w-full"
                  ></img>
                </div>
                <h3 className="text-lg font-semibold text-gray-500 mt-2">
                  WHY Florist for{" "}
                  <span className="text-gray-700 hover:underline"><Link to="/products/detail/22">Anniversarry</Link></span>
                </h3>
              </div>
              <div>
                <div className="bg-gray-300 h-60">
                  <img
                    src="https://cdn.shopify.com/s/files/1/1789/5809/files/04-bunga-papan.jpg?v=1590989392"
                    className="bg-gray-300 h-60 object-cover w-full"
                  ></img>
                </div>
                <h3 className="text-lg font-semibold text-gray-500 mt-2">
                  WHY Florist for <span className="text-gray-700 hover:underline"><Link to="/products/detail/20">Wedding</Link></span>
                </h3>
              </div>

              <div>
                <div className="bg-gray-300 h-60">
                  <img
                    src="https://cdn.shopify.com/s/files/1/1789/5809/files/NEW-anniversary-Category_button.jpg?v=1590989418"
                    className="bg-gray-300 h-60 object-cover w-full"
                  ></img>
                </div>
                <h3 className="text-lg font-semibold text-gray-500 mt-2">
                  WHY Florist for{" "}
                  <span className="text-gray-700 hover:underline"><Link to="/products/detail/26">Romance</Link></span>
                </h3>
              </div>
              <div>
                <div className="bg-gray-300 h-60">
                  <img
                    src="https://cdn.shopify.com/s/files/1/1789/5809/files/03-trinity_844c22ea-294c-4873-b611-791cefb7feed.jpg?v=1590989384"
                    className="bg-gray-300 h-60 object-cover w-full"
                  ></img>
                </div>
                <h3 className="text-lg font-semibold text-gray-500 mt-2">
                  WHY Florist for{" "}
                  <span className="text-gray-700 hover:underline"><Link to="/products/detail/23">Get Well Soon</Link></span>
                </h3>
              </div>
              <div>
                <div className="bg-gray-300 h-60">
                  <img
                    src="https://cdn.shopify.com/s/files/1/1789/5809/files/01-birthday_80ad8c6f-7c3a-4a7a-a177-d19f6105d478.jpg?v=1590989317"
                    className="bg-gray-300 h-60 object-cover w-full"
                  ></img>
                </div>
                <h3 className="text-lg font-semibold text-gray-500 mt-2">
                  WHY Florist for{" "}
                  <span className="text-gray-700 hover:underline"><Link to="/products/detail/25">Graduation</Link></span>
                </h3>
              </div>
            </div>
            {/* <hr className="w-40 my-14 border-4 rounded-md sm:mx-0 mx-auto" /> */}
          </section>
          <br></br>
          <br></br>
          <hr></hr>
          <br></br>
          <br></br>
          <section>
            <h1 className="inline-block text-rose-400 font-bold text-3xl">
              The No.1 florist in Indonesia <br />
              (service advantages).
            </h1>

            <div className="grid grid-cols-3 gap-4 mt-10">
              <div>
                <h3 className="text-lg font-semibold text-gray-500 mt-2">
                  1. Browse and order
                </h3>
                <p className="text text-gray-400">
                  Start by searching for the flowers. Once you find flower you
                  like, simply check the stock, order it, and make a secure
                  payment right away.
                </p>
              </div>
              <div>
                <h3 className="text-lg font-semibold text-gray-500 mt-2">
                  2. Fast and Coverage Shipping
                </h3>
                <p className="text text-gray-400">
                  Same day delivery for order placed before 3PM and full
                  delivery coverage across Indonesia.
                </p>
              </div>
              <div>
                <h3 className="text-lg font-semibold text-gray-500 mt-2">
                  3. Best Quality Flowers
                </h3>
                <p className="text text-gray-400">
                  Our flower is flowers from top rated local florist in
                  Indonesia. Fresh and carefully store.
                </p>
              </div>
            </div>
          </section>
          <div className="mt-14">
            {/* <p>Ps. You can also become a WHY Florist host in few clicks!</p> */}
          </div>
        </main>

        
       
        <script src="../path/to/flowbite/dist/flowbite.js"></script>
      </body>
    </div>
  );
}
